import { requestLowCode } from '@/utils/lowcodeRequest';

export async function getLowCodeConfig (params) {
    return requestLowCode.post(`/system-page/getSchema`, params);
  }
  